<template>
  <b-dropdown :triggers="['hover']" aria-role="list" position="is-bottom-left">
    <template #trigger>
      <b-button
        :type="{
          'is-white': t.details.status === 'open',
          'is-success': t.details.status === 'success' && !isCancelPending,
          'is-smart-orange-7': t.details.status === 'refused',
          'is-light': t.details.status === 'cancelled',
          'is-warning': t.details.status === 'error' || isCancelPending,
          'is-dark': t.details.status === 'refunded',
          'is-danger': t.details.status === 'chargeback',
          'is-sea': t.details.status === 'pending'
        }"
        :disabled="t.details.status === 'cancelled'"
        slot="trigger"
      >
        {{
          t.details.status === "success"
            ? isCancelPending
              ? $t("transactions.statusCancelPending")
              : $t("transactions.statusSuccess")
            : t.details.status === "refused"
            ? $t("transactions.statusRefused")
            : t.details.status === "error"
            ? $t("transactions.statusError")
            : t.details.status === "cancelled"
            ? $t("transactions.statusCancelled")
            : t.details.status === "open"
            ? $t("transactions.statusOpen")
            : t.details.status === "pending"
            ? $t("transactions.statusPending")
            : t.details.status === "refunded"
            ? $t("transactions.statusRefunded")
            : t.details.status === "chargeback"
            ? $t("transactions.statusChargeback")
            : "-"
        }}
      </b-button>
    </template>

    <div v-if="t.details.status !== 'cancelled'">
      <b-dropdown-item aria-role="listitem">
        <p>{{ paymentMethods }}</p>
      </b-dropdown-item>

      <b-dropdown-item
        aria-role="listitem"
        v-if="['refused', 'error'].includes(t.details.status) && t.tefTerminal && t.tefTerminal.response"
      >
        <b>{{ $t("transactions.response") }}: </b>
        {{ t.tefTerminal.response.message }}
      </b-dropdown-item>

      <b-dropdown-item
        aria-role="listitem"
        v-if="letter"
        @click="downloadLetter"
      >
        <b-icon icon="file-download"></b-icon>
        {{ $t("transactions.downloadCancelLetter") }}
      </b-dropdown-item>

      <b-dropdown-item aria-role="listitem" v-if="isCancelFailed">
        <b class="has-text-danger">
          {{ $t("transactions.statusCancelFailed") }}
        </b>
        <br v-if="cancelError" />
        <small v-if="cancelError">{{ cancelError }}</small>
      </b-dropdown-item>

      <b-dropdown-item aria-role="listitem" v-if="isCancelable">
        <button
          class="button is-danger"
          @click="$emit('cancel-transaction', t)"
        >
          {{ $t("transactions.cancelTransaction") }}
        </button>
      </b-dropdown-item>
    </div>
    <dropdown-item-combo :t="t" />
  </b-dropdown>
</template>

<script>
import dropdownItemCombo from "./DropdownItemCombo.vue";

export default {
  components: {
    dropdownItemCombo
  },

  props: ["t"],

  computed: {
    paymentMethods() {
      let p = [];

      if (this.t.details.fundingSource === "credit") {
        p.push(this.$t("transactions.credit"));
      }

      if (this.t.details.fundingSource === "debit") {
        p.push(this.$t("transactions.debit"));
      }

      return p.join(" + ");
    },

    letter() {
      const refund = [...(this.t.refunds || [])].reverse().find(r => {
        const source = r.sources && r.sources.paymentMethod;
        return source && source.provider === "linx" && source.letter;
      });

      return refund ? refund.sources.paymentMethod.letter : null;
    },

    // Último pedido de cancelamento (Linx) feito pra essa transação, se houver.
    activeLinxRefund() {
      return [...(this.t.refunds || [])].reverse().find(r => {
        const source = r.sources && r.sources.paymentMethod;
        return source && source.provider === "linx";
      });
    },

    isCancelPending() {
      return !!this.activeLinxRefund && this.activeLinxRefund.status === "open";
    },

    isCancelFailed() {
      return !!this.activeLinxRefund && this.activeLinxRefund.status === "error";
    },

    cancelError() {
      return this.activeLinxRefund && this.activeLinxRefund.sources.paymentMethod.error;
    },

    isCancelable() {
      return (
        this.t.details.provider === "linx-paykit-tef" &&
        this.t.details.status === "success" &&
        !this.isCancelPending
      );
    }
  },

  methods: {
    downloadLetter() {
      window.open(this.letter, "_blank");
    }
  }
};
</script>

<style scoped>
.is-white,
.is-white:hover {
  border: 1px solid #dedede;
}
</style>
